import React, { useState } from "react";
import { db } from "../firebaseConfig";
import { collection, query, where, getDocs, deleteDoc, doc } from "firebase/firestore";

const DeleteEmptyTitleIssues = () => {
  const [loading, setLoading] = useState(false);
  const [deletedCount, setDeletedCount] = useState(0);
  const [error, setError] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    setDeletedCount(0);

    try {
      // Query documents where title is exactly an empty string
      const q = query(collection(db, "common_issues"), where("title", "==", ""));
      const snapshot = await getDocs(q);

      let deleteCounter = 0;
      for (const docSnap of snapshot.docs) {
        await deleteDoc(doc(db, "common_issues", docSnap.id));
        deleteCounter++;
      }

      setDeletedCount(deleteCounter);
    } catch (err) {
      console.error("Error deleting empty title issues:", err);
      setError(err.message || "Error occurred");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: 20, border: "1px solid #ccc", maxWidth: 400 }}>
      <h3>Delete Issues with Empty Title</h3>
      <button onClick={handleDelete} disabled={loading}>
        {loading ? "Deleting..." : "Delete Empty Title Records"}
      </button>
      {deletedCount > 0 && <p>Deleted {deletedCount} record(s).</p>}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}
    </div>
  );
};

export default DeleteEmptyTitleIssues;
